import { Modal } from "@/frontend/shared/ui/Modal";
import { SelectionDropdown } from "@/frontend/shared/ui/SelectionDropdown";
import styles from "./EditUserRoleModal.module.scss";
import { useState } from "react";
import { NormalButton } from "@/frontend/shared/ui/Button";

export function EditUserRoleModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const options = [
    { label: "Admin", value: "Admin" },
    { label: "User", value: "User" }
  ];
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [role, setRole] = useState(options[0].label);
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit Role">
      <div className={styles.container}>
        <SelectionDropdown
          options={options}
          onSelect={() => setIsDropdownOpen(true)}
          onFocus={() => setIsDropdownOpen(true)}
          onChange={(e) => {
            setRole(e as string);
            setIsDropdownOpen(false);
          }}
          onClose={() => setIsDropdownOpen(false)}
          value={role}
          defaultValue={role}
          isOpen={isDropdownOpen}
          inputSize="large"
        />
        <div className={styles.buttonsContainer}>
          <div className={styles.divider} />
          <NormalButton size="medium">Save</NormalButton>
        </div>
      </div>
    </Modal>
  );
}
